import airports from 'src/dicts/airports/airports';
import cities from 'src/dicts/cities/cities';
import type { Trip } from 'src/types';

/**
 * Убирает транзитные перелеты из общего списка перелетов.
 * Напр. Москва – Питер(пересадка) – Лондон -> Москва – Лондон
 * @param trips
 */
export const omitTransitFlights = (
  trips: Trip[]
): {
  locations: string[];
  dates: string[];
} => {
  const flights = {
    locations: [] as string[],
    dates: [] as string[],
  };

  let index = 0;
  let continued = false;

  while (index < trips.length) {
    if (!continued) {
      flights.locations.push(
        cities[trips[index].fromCityId].name || airports[trips[index].fromId].name
      );
      flights.dates.push(trips[index].startDate);
    }

    if (trips[index].continued) {
      continued = true;
    } else {
      continued = false;

      flights.locations.push(
        cities[trips[index].toCityId].name || airports[trips[index].toId].name
      );
    }

    index += 1;
  }

  return flights;
};
